// import './assets/css/init.css';
import 'element-ui/lib/theme-chalk/index.css';

import Vue from 'vue'
import App from './App.vue'

import VueJsonPretty from 'vue-json-pretty'
import 'vue-json-pretty/lib/styles.css'
Vue.component("vue-json-pretty", VueJsonPretty)

import JsonViewer from 'vue-json-viewer'
Vue.use(JsonViewer)

// UI
import ElementUI from 'element-ui'
import zhLocale from 'element-ui/lib/locale/lang/zh-CN'
Vue.use(ElementUI, {zhLocale})

// 复制到剪贴板
import VueClipboard from 'vue-clipboard2'
Vue.use(VueClipboard)

/*********** 扩展数据 ***********/
// 基础公共方法配置
import utilsBase from './extension/utils.base.js';
Vue.use(utilsBase);

// 扩展方法配置
import utilsEditor from './extension/utils.editor.js';
Vue.use(utilsEditor);

// // electron公共方法配置
// import utilsElectron from './extension/utils.electron.js';
// Vue.use(utilsElectron);

// 项目公共方法配置
import utilsProject from './extension/utils.js';
Vue.use(utilsProject);

Vue.config.productionTip = false

new Vue({
  render: h => h(App),
}).$mount('#app')
